import styled from 'styled-components';

import { IconFormIndicatorInfoCurrentColor } from '@components/icons/form-indicator-info-current-color';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

type AssistantMaxRoundsMessageProps = {
  text: string;
};

export const AssistantMaxRoundsMessage = ({ text }: AssistantMaxRoundsMessageProps) => {
  const { t } = useScopedTranslate(locale);
  const message = text.trim() ? text : t('maxRoundsMessage');

  return (
    <LimitMessageContainer>
      <Stack orientation="horizontal" space={2}>
        <LimitInfoIcon>
          <IconFormIndicatorInfoCurrentColor />
        </LimitInfoIcon>
        <Text color="textSecondary" font="regular14" text={message} />
      </Stack>
    </LimitMessageContainer>
  );
};

const LimitMessageContainer = styled.div({
  width: '100%',
  borderRadius: pxToRem(7),
  padding: pxToRem(12),
  background: theme.color.uiTrans5,
  border: `${pxToRem(1)} solid ${theme.color.border10}`,
});

const LimitInfoIcon = styled.div({
  color: theme.color.textHelper,
  lineHeight: 0,
});

const locale = {
  en: {
    maxRoundsMessage: 'This request reached the step limit. Send another message to continue.',
  },
};
